export class ATCCodeFilterSettingsModel {
  public atcCode: string;
  public atcName: string;
}